import { render, staticRenderFns } from "./ModalIdle.vue?vue&type=template&id=55c5eb8e&scoped=true&"
import script from "./ModalIdle.vue?vue&type=script&lang=js&"
export * from "./ModalIdle.vue?vue&type=script&lang=js&"
import style0 from "./ModalIdle.vue?vue&type=style&index=0&id=55c5eb8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c5eb8e",
  null
  
)

export default component.exports